export default class LLMTimimgs {
    msgSentAt: null | number = null;
    firstTokenAt: null | number = null;
    firstTokenDelta: number = 0;
    responseTime: number = 0;
    numTokens: number = 0;

    reset() {
        this.msgSentAt = null;
        this.firstTokenAt = null;
    }

    inferenceStart() {
        this.msgSentAt = performance.now();
        this.numTokens = 0;
    }

    newInferenceResult() {
        if (this.msgSentAt) {
            this.firstTokenDelta = performance.now() - this.msgSentAt;
            this.firstTokenAt = performance.now();

            this.msgSentAt = null;
        }
        this.numTokens += 1;
    }

    inferenceDone() {
        this.responseTime = performance.now() - this.firstTokenAt!;
    }
}